export const COMPLIANCE_CHECKLIST_ITEMS = [
  'Informed consent obtained verbally from patient/guardian or via Dentistry.One Platform upon platform entry',
  'Procedures, Alternatives, Risks and Questions were addressed with the patient/guardian',
  'Medical History reviewed',
  'Any additional people present during call? (If applicable)',
];

export const getAssignedProviderName = (providerName?: string | null, fallbackName?: string | null): string =>
  providerName?.trim() || fallbackName?.trim() || 'the assigned provider';

const COMPLIANCE_ATTESTATION_CONFIRMATION = 'confirm all of the above and that the Oral Health Report is correct';

export const getComplianceAttestationLabel = (providerName?: string | null, fallbackName?: string | null): string =>
  `I, ${getAssignedProviderName(providerName, fallbackName)}, ${COMPLIANCE_ATTESTATION_CONFIRMATION}`;
